// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"104d3c41","96":"4b19a5a9","787":"a34e9b70"}[chunkId] + ".chunk.js";
};